import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import CommonFooter from "../components/CommonFooter/CommonFooter";
import DeliveryPolicy from "../components/Policy/DeliveryPolicy";

const DeliveryPolicyPage = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      <DeliveryPolicy />
      <CommonFooter />
    </div>
  );
};

export default DeliveryPolicyPage;
